import { useEffect, useState, useCallback } from 'react'
import { useDispatch, useSelector } from 'react-redux'
import { useNavigate, useParams } from 'react-router-dom'
import { addUserInternalTagtStart, getAllBonusStart } from '../../../store/redux-slices/admins'
import { getBonusStart, issueBonusStart } from '../../../store/redux-slices/bonus'
import { getCountriesStart, getSAUserDocumentStart, getUserStart, verifyUserDocumentStart, deleteUserStart } from '../../../store/redux-slices/fetchData'
import { getDocumentLabelStart, sendEmailStart, updateAffiliateStatusStart, updateDocumentStart, updateSAUserStatusStart, verifyOrMarkSuspiciousUserStart } from '../../../store/redux-slices/superAdminSettings'
import { addAffiliateUserStart, getDuplicateUsersStart, resetPasswordEmailStart, resetUserPasswordStart, updateTagsStart, updateUserAffiliateStart, verifyUserEmailStart } from '../../../store/redux-slices/tenantUsers'
import { sendUserPromoCodeStart } from '../../../store/redux-slices/promoCodesSlice'
import { getDocumentLabel } from '../../../utils/apiCalls'
import { formatDateYMD } from '../../../utils/dateFormatter'
import { safeStringify } from '../../../utils/helpers'
import { getAllemailTemplatesStart } from '../../../store/redux-slices/emailTemplate'
import { EMAIL_TEMPLATE_HIDDEN } from "./constants"
import useCheckPermission from "../../../utils/checkPermission";
import { toast } from '../../../components/Toast'

// import { safeStringify } from '../../../utils/helpers'

const useUserDetails = () => {
  const [selectedTab, setSelectedTab] = useState('overview')
  const { userData, loading, updateUserAffiliateLoading, addUserAffiliateLoading } = useSelector((state) => state.fetch)
  const { documentLabels } = useSelector(state => state.superAdminSettings)
  const { bonusList } = useSelector((state) => state.admins)
  const { bonusDetail } = useSelector((state) => state.bonus)
  const { userId } = useParams()
  const dispatch = useDispatch()
  const { userDocuments } = useSelector(state => state.fetch)
  const [show, setShow] = useState(false)
  const [status, setStatus] = useState('')
  const [userDocumentId, setUserDocumentId] = useState('')
  const [showReasonModal, setShowReasonModal] = useState(false)
  const [enable, setEnable] = useState(false)
  const [docLabels, setDocLabels] = useState('')
  const [title, setTitle] = useState('')
  const [imagePreviewModalShow, setImagePreviewModalShow] = useState(false)
  const [imageUrl, setImageUrl] = useState({ name: '', preview: [] })
  const [showModal, setShowModal] = useState(false)
  const [freespinModal, setFreeSpinModal] = useState(false)
  const [showManageMoneyModal, setShowManageMoneyModal] = useState(false)
  const [selectedBonus, setSelectedBonus] = useState()
  const [bonusLoading, setBonusLoading] = useState(false)
  const [bonusAmount, setBonusAmount] = useState()
  const [isInternalModal, setIsInternalModal] = useState(false)
  const [name, setName] = useState('')
  const [showRemoveAffiliate, setShowRemoveAffiliate] = useState(false)
  const [showAddAffiliate, setShowAddAffiliate] = useState(false)
  const [labelName, setLabelName] = useState('')
  const [isActiveInactivemodalVisible, setActiveInactiveModal] = useState(false)
  const [verifyEmailModal, setVerifyEmailModal] = useState(false)
  const [sendEmailModal, setSendEmailModal] = useState(false)
  const [showPromoCodeModal, setShowPromoCodeModal] = useState(false)
  const [userPasswordModal, setUserPasswordModal] = useState(false)
  const [passwordEmailModal, setPasswordEmailModal] = useState(false)
  const [editUserModal, setEditUserModal] = useState(false)
  const navigate = useNavigate()
  const [tagOptions, setTagOptions] = useState()
  const [selectedTag, setSelectedTag] = useState()
  const { duplicateUsers } = useSelector(state => state.tenantUsers)
  const { activePromoCodes } = useSelector(state => state.promoCodes)
  const [showTagModal, setShowTagModal] = useState(false)
  const [showDuplicateModal, setShowDuplicateModal] = useState(false)
  const [showBonusModal, setShowBonusModal] = useState(false)
  const [limit, setLimit] = useState(15)
  const [pageNo, setPageNo] = useState(1)
  const [showAffiliateModal, setShowAffiliateModal] = useState(false)
  const [showVerifyOrSuspiciousUserModal, setShowVerifyOrSuspiciousUserModal] = useState(false);
  const [isVerifyUser, setIsVerifyUser] = useState(true)
  const [deletePlayer, setDeletePlayer] = useState({ isOpen: false, id: "" })
  const { isHidden } = useCheckPermission()


  const { emailTemplates } = useSelector((state) => state.emailTemplate)

  useEffect(() => {
    if (!isHidden({ module: { key: "EmailTemplate", value: "R" } })) {
      dispatch(getAllemailTemplatesStart({ isTenant: true }))
    }
  }, [])

  const handleClose = () => {
    setShowReasonModal(false)
    setEnable(false)
  }

  const handleVerifyEmail = () => {
    dispatch(verifyUserEmailStart({ isTenant: false, data: { userId: parseInt(userId) } }))
    setVerifyEmailModal(false)
  }

  const handleVerifyOrSuspiciousUser = (userData) => {
    const data = {
      userId: userData.userId,
    };

    if (isVerifyUser) {
      data.verified = true
    } else {
      if (userData.isSuspicious) {
        data.suspicious = false
      } else {
        data.suspicious = true
      }
    }

    dispatch(verifyOrMarkSuspiciousUserStart({ data }))

    setShowVerifyOrSuspiciousUserModal(false);

    setTimeout(() => {
      dispatch(getUserStart({ userId }))
      dispatch(getSAUserDocumentStart({ userId }))
      if (!isHidden({ module: { key: "KycLabel", value: "R" } })) {
        dispatch(getDocumentLabelStart({ userId: parseInt(userId) }))
      }
    }, 1000)
  }

  const fetchSABonus = () => {
    dispatch(getAllBonusStart({
      adminId: '',
      tenantId: '',
      limit: '',
      pageNo: '',
      search: '',
      bonusType: safeStringify(['deposit']),
      isActive: ''
    }))
  }

  useEffect(() => {
    let timer = null;
    if (bonusLoading) {
      timer = setTimeout(() => {
        setBonusLoading(false)
      }, 1000);
    }
    return () => clearTimeout(timer);
  }, [bonusLoading])

  useEffect(() => {
    dispatch(getUserStart({ userId }))
    dispatch(getSAUserDocumentStart({ userId }))
    if (!isHidden({ module: { key: "KycLabel", value: "R" } })) {
      dispatch(getDocumentLabelStart({ userId }))
    }
    fetchSABonus()
  }, [userId])

  const handleYes = (reason, request, labelName) => {
    if (request === 'request' || request === 'cancel') {
      dispatch(updateDocumentStart({ data: { labelName, documentLabelId: userDocumentId, reason, userId: parseInt(userId), reRequested: true }, isRequested: (request === 'request') }))
    } else {
      dispatch(verifyUserDocumentStart({ userId, data: { userDocumentId, reason, status, userId: parseInt(userId) } }))
    }
    setShow(false)
    setShowReasonModal(false)
    setStatus('')
  }

  const handleVerify = (modalStatus, userDocumentId, myName) => {
    setStatus(modalStatus)
    setName(myName)
    setUserDocumentId(userDocumentId)
    if (modalStatus === 'approved') {
      setShow(true)
      setShowReasonModal(false)
    } else {
      setShow(false)
      setShowReasonModal(true)
    }
    setTitle('Rejecting')
  }

  useEffect(() => {
    if (!docLabels) {
      async function fetchData() {
        await getDocumentLabel('').then((res) => {
          setDocLabels(res?.data?.data?.documentLabel)
        })
      }
      fetchData()
    }
    dispatch(getCountriesStart({ limit: '', name: '', pageNo: '', isActive: '', kycMethod: '' }))
  }, [])

  // useEffect(() => {
  //   dispatch(getAllBonusStart({ userId, bonusType: safeStringify(['match', 'balance', 'wagering']) }))
  // }, [showModal])

  useEffect(() => {
    if (!selectedBonus && bonusList?.length > 0) {
      setSelectedBonus(bonusList?.[0])
    }
    if (selectedBonus) {
      dispatch(getBonusStart({ userBonusId: '', bonusId: selectedBonus?.bonusId, isTenant: false }))
    }
  }, [bonusList, selectedBonus?.bonusId])

  const updateDocument = ({ documentLabelId, isRequested, labelName }) => {
    dispatch(updateDocumentStart({ data: { labelName, documentLabelId, userId: parseInt(userId) }, isRequested }))
  }

  const handleReRequest = (docId, myStatus, myName, myLabelName) => {
    setStatus('')
    setName(myName)
    setLabelName(myLabelName)
    if (myStatus === 'cancel') {
      setShow(true)
      setShowReasonModal(false)
    } else {
      setShow(false)
      setShowReasonModal(true)
    }
    setUserDocumentId(docId)
    setTitle('Re-Requesting')
  }

  const handleImagePreview = (documentUrl, name) => {
    setImageUrl({ name, preview: documentUrl })
    setImagePreviewModalShow(true)
  }

  const issueBonusHandler = () => {
    setShowModal(false)
    dispatch(issueBonusStart({ data: { userId: parseInt(userId), bonusId: selectedBonus?.bonusId, amount: bonusAmount } }))
    setBonusAmount('')
  }

  const showStyle = (data) => (data ? 'text-success' : 'text-danger')
  const printData = (data) => (data ? 'Yes' : 'No')

  const removeAffiliateHandler = () => {
    dispatch(updateUserAffiliateStart({ data: { userId, tenantId: userData?.tenantId, affiliateStatus: false }, isSuperAdmin: true, setShowRemoveAffiliate }))
  }

  const addAffiliateHandler = () => {
    if (userData?.trackingToken && userData?.isAffiliateUpdated === false) {
      dispatch(addAffiliateUserStart({ data: { userId, tenantId: userData?.tenantId, trackingToken: userData?.trackingToken }, isSuperAdmin: true, setShowAddAffiliate }))
    }
  }

  const hendleGender = (gender) => {  
    if (gender === 'M') {
      return 'Male';
    } else if (gender === 'F') {
      return 'Female';
    } else 
      return gender ;
    
  }

  const basicInfo = [
    { label: 'ID', value: userId },
    { label: 'Email', value: userData?.email },
    { label: 'Email Verified', value: printData(userData?.isEmailVerified), subValue: showStyle(userData?.isEmailVerified) },
    { label: 'Full Name', value: `${userData?.firstName} ${userData?.lastName}` },
    { label: 'User Name', value: userData?.username },
    { label: 'Gender', value: hendleGender(userData?.gender) },
    { label: 'Date Of Birth', value: formatDateYMD(userData?.dateOfBirth) },

    { label: 'Status', value: userData?.isActive ? 'Active' : 'In -Active', subValue: showStyle(userData?.isActive) },
    { label: 'In-Active Reason', value: userData?.defaultDisableReason || '-' },
    // { label: 'Portal', value: `${userData?.tenant?.name} (${userData?.tenant?.domain})` },
    { label: 'Reason', value: !userData?.isActive ? userData?.reason : '' },
    // {
    //   label: 'Tags',
    //   value: userData?.tags
    //     ? userData?.tags?.length < 1 ? 'N/A' : userData?.tags?.join(', ')
    //     : 'N/A'
    // },
    // { label: 'SumSub Applicant Id', value: userData?.applicantId },
    // { label: 'KYC Method', value: userData?.kycMethod === 1 ? 'Sumsub' : 'System KYC' },
    // { label: 'KYC Status', value: userData?.kycMethod === 1 ? userData?.sumsubKycStatus?.toUpperCase() : userData?.kycStatus }
  ]

  const kycInfo = [
    { label: 'KYC Status', value: userData?.kycMethod === 1 ? userData?.sumsubKycStatus?.toUpperCase() : userData?.kycStatus }
  ];

  const contactInfo = [
    { label: 'Phone Number', value: userData?.phone },
    { label: 'Address', value: userData?.address + (userData?.city ? ', ' + userData?.city : '') + (userData?.zipCode ? ', ' + userData?.zipCode : '') },
    { label: 'Country Code', value: userData?.countryCode },
  ];

  const internalPlayerHandler = async () => {
    await dispatch(addUserInternalTagtStart({ data: { userId } }))
    setIsInternalModal(false)
    setTimeout(() => {
      dispatch(getUserStart({ userId }))
      dispatch(getSAUserDocumentStart({ userId }))
      if (!isHidden({ module: { key: "KycLabel", value: "R" } })) {
        dispatch(getDocumentLabelStart({ userId: parseInt(userId) }))
      }
    }, 1000)
  }

  const updateUserStatus = (res) => {
    dispatch(updateSAUserStatusStart({
      data: {
        ...res,
        code: 'USER',
        userId,
        status: !userData.isActive,
        tenantId: userData.tenantId
      }
    }))
    setTimeout(() => {
      dispatch(getUserStart({ userId }))
      dispatch(getSAUserDocumentStart({ userId }))
      dispatch(getDocumentLabelStart({ userId: parseInt(userId) }))
    }, 1000)
  }

  const sendEmail = (res) => {
    console.log('res', res);
    dispatch(sendEmailStart({
      data: {
        ...res,
        userIds: [userId],
      }
    }))
  }

  const sendPromoCode = ({ promocodesId }) => {
    const selected = activePromoCodes?.find(c => String(c.promocodesId) === String(promocodesId))
    dispatch(sendUserPromoCodeStart({
      userId: parseInt(userId),
      promoCode: selected?.code,
      onSuccess: () => setShowPromoCodeModal(false),
    }))
  }

  const handleResetPasswordEmail = () => {
    dispatch(resetPasswordEmailStart({
      isTenant: false,
      data: { userId: parseInt(userData?.userId) }
    }))
    setPasswordEmailModal(false)
  }

  const handleResetUserPassword = (data) => {
    dispatch(resetUserPasswordStart({
      isTenant: false,
      ...data
    }))
    setUserPasswordModal(false)
  }

  // const filterEmailTemplate = (data) => {
  //   if (!data) return {};

  //   const filtered = Object.fromEntries(
  //     Object.entries(data).filter(([key]) => !EMAIL_TEMPLATE_HIDDEN.includes(key))
  //   );

  //   return filtered;
  // };

  const filterEmailTemplate = useCallback((data) => {
    if (!data) return {};

    return Object.fromEntries(
      Object.entries(data).filter(([key]) => !EMAIL_TEMPLATE_HIDDEN.includes(key))
    );
  }, [emailTemplates]);

  useEffect(() => {
    if (userData?.tags?.length > 0) {
      const options = []
      for (const i in userData?.tags) {
        if (userData?.tags[i] !== '' && userData?.tags[i] !== null) {
          options.push({ label: userData?.tags[i], value: userData?.tags[i] })
        }
      }
      setTagOptions(options)
    }
  }, [userData?.tags])

  useEffect(() => {
    const tag = []
    for (const i in userData?.tags) {
      userData?.tags[i] !== null && tag.push({ label: userData?.tags[i], value: userData?.tags[i] })
    }
    setSelectedTag(tag)
  }, [userData?.tags])

  const updateTags = (formValues) => {
    const tags = []
    let customTag = false
    for (const tag in formValues?.tags) {
      tags.push(formValues?.tags[tag]?.value)
      if (formValues?.tags[tag]?.isNew) {
        customTag = true
      }
    }
    dispatch(updateTagsStart({
      data: {
        tenantId: userData?.tenantId && JSON.parse(userData?.tenantId),
        userId: userId && JSON.parse(userId),
        parentId: userData.parentId,
        tags,
        customTag
      },
      isTenant: false
    }))
  }

  const addTag = () => {
    setShowTagModal(true)
  }

  const getDuplicateUsers = () => {
    setShowDuplicateModal(true)
  }

  const makeAffiliateHandler = () => {
    dispatch(updateAffiliateStatusStart({
      data: {
        userId: userData.userId,
        status: 'approved',
        reason: ''
      }
    }))
    setShowAffiliateModal(false)
  }

  useEffect(() => {
    dispatch(getDuplicateUsersStart({
      limit,
      pageNo,
      userId,
      isTenant: false
    }))
  }, [limit, pageNo])

  const onHandleDeleteYes = () => {
    dispatch(deleteUserStart({
      data: { userId: deletePlayer?.data?.userId },
      onSuccess: () => {
        toast('Player deleted successfully', 'success')
        navigate(-1)
        setDeletePlayer({ isOpen: false, id: "" })
      },
      onError: (error) => {
        toast(error.message || 'Something went wrong', 'error')
      }
    }))


  }

  return {
    bonusList,
    selectedTab,
    userData,
    loading,
    userDocuments,
    documentLabels,
    show,
    status,
    showReasonModal,
    title,
    imagePreviewModalShow,
    imageUrl,
    enable,
    docLabels,
    showModal,
    selectedBonus,
    bonusDetail,
    bonusAmount,
    basicInfo,
    kycInfo,
    contactInfo,
    freespinModal,
    showManageMoneyModal,
    showAddAffiliate,
    labelName,
    setShowAddAffiliate,
    setBonusAmount,
    issueBonusHandler,
    setSelectedBonus,
    setShowModal,
    setSelectedTab,
    handleVerify,
    updateDocument,
    setShow,
    handleYes,
    handleClose,
    setEnable,
    handleReRequest,
    setImagePreviewModalShow,
    handleImagePreview,
    setImageUrl,
    setShowManageMoneyModal,
    setFreeSpinModal,
    setIsInternalModal,
    isInternalModal,
    internalPlayerHandler,
    name,
    addUserAffiliateLoading,
    showRemoveAffiliate,
    updateUserAffiliateLoading,
    removeAffiliateHandler,
    setShowRemoveAffiliate,
    addAffiliateHandler,
    navigate,
    isActiveInactivemodalVisible,
    setActiveInactiveModal,
    updateUserStatus,
    verifyEmailModal,
    setVerifyEmailModal,
    handleVerifyEmail,
    setPasswordEmailModal,
    setUserPasswordModal,
    userPasswordModal,
    passwordEmailModal,
    handleResetPasswordEmail,
    handleResetUserPassword,
    editUserModal,
    setEditUserModal,
    limit,
    pageNo,
    setLimit,
    setPageNo,
    showTagModal,
    showDuplicateModal,
    setShowTagModal,
    setShowDuplicateModal,
    updateTags,
    tagOptions,
    setTagOptions,
    selectedTag,
    setSelectedTag,
    addTag,
    getDuplicateUsers,
    duplicateUsers,
    bonusLoading,
    setBonusLoading,
    sendEmailModal,
    setSendEmailModal,
    showPromoCodeModal,
    setShowPromoCodeModal,
    emailTemplates: filterEmailTemplate(emailTemplates),
    sendEmail,
    sendPromoCode,
    showBonusModal,
    setShowBonusModal,
    showAffiliateModal,
    setShowAffiliateModal,
    makeAffiliateHandler,
    setShowVerifyOrSuspiciousUserModal,
    showVerifyOrSuspiciousUserModal,
    isVerifyUser,
    setIsVerifyUser,
    handleVerifyOrSuspiciousUser,
    filterEmailTemplate,
    setDeletePlayer,
    deletePlayer,
    onHandleDeleteYes
  }
}

export default useUserDetails
